import { ProductType } from "../helpers/enums/productType";

export const services: Record<ProductType, { url: string; docs: string }> = {
  [ProductType.IP]: {
    url: "https://www.surf.nl/diensten/internet",
    docs: "https://servicedesk.surf.nl/wiki/spaces/WIKI/pages/111706375/i.+Dienstcomponent+-+Internet",
  },
  [ProductType.LightPath]: {
    url: "https://www.surf.nl/diensten/evpn",
    docs: "https://servicedesk.surf.nl/wiki/spaces/WIKI/pages/111706377/ii.+Dienstcomponent+-+Private+Connectivity+-+EVPN",
  },
  [ProductType.L2VPN]: {
    url: "https://www.surf.nl/diensten/evpn",
    docs: "https://servicedesk.surf.nl/wiki/spaces/WIKI/pages/111706377/ii.+Dienstcomponent+-+Private+Connectivity+-+EVPN",
  },
  [ProductType.Port]: {
    url: "https://servicedesk.surf.nl/wiki/spaces/WIKI/pages/111706368/a.+Wat+zijn+Service+Ports",
    docs: "https://servicedesk.surf.nl/wiki/spaces/WIKI/pages/111706368/a.+Wat+zijn+Service+Ports",
  },
  [ProductType.L3VPN]: {
    url: "https://servicedesk.surf.nl/wiki/spaces/WIKI/pages/111706379/",
    docs: "https://servicedesk.surf.nl/wiki/spaces/WIKI/pages/111706379/iii.+Dienstcomponent+-+Private+Connectivity+-+L3VPN",
  },
  [ProductType.IPPrefixes]: {
    url: "https://www.surf.nl/surfinternet-een-snelle-betrouwbare-internetverbinding",
    docs: "",
  },
  [ProductType.Wireless]: {
    url: "https://www.surf.nl/diensten/surfwireless",
    docs: "https://servicedesk.surf.nl/wiki/spaces/WIKI/pages/198967459/SURFwireless",
  },
  [ProductType.Wired]: {
    url: "https://www.surf.nl/diensten/netwerkconnectiviteit",
    docs: "",
  },
  [ProductType.Firewall]: {
    url: "https://www.surf.nl/surffirewall-een-goed-afgeschermd-netwerk-zonder-zorgen",
    docs: "https://servicedesk.surf.nl/wiki/spaces/WIKI/pages/147095560/SURFfirewall",
  },
  [ProductType.SURFcert]: {
    url: "https://www.surf.nl/surfcert-247-ondersteuning-bij-beveiligingsincidenten",
    docs: "",
  },
  [ProductType.SURFdomeinen]: {
    url: "https://www.surf.nl/diensten/netwerkconnectiviteit/surfdomeinen",
    docs: "",
  },
  [ProductType.IoTnet]: {
    url: "",
    docs: "",
  },
};
